import { render, staticRenderFns } from "./StudentsPendingGraph.vue?vue&type=template&id=e82c9eb6&scoped=true"
import script from "./StudentsPendingGraph.vue?vue&type=script&lang=js"
export * from "./StudentsPendingGraph.vue?vue&type=script&lang=js"
import style0 from "./StudentsPendingGraph.vue?vue&type=style&index=0&id=e82c9eb6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e82c9eb6",
  null
  
)

export default component.exports